<template>
    <div class="common-page">
        <div class="full-banner">
            <div class="wrapper">
                <h1>Fale conosco</h1>
            </div>
        </div>
        <div class="wrapper" style="padding-top: 40px; padding-bottom: 40px;">
            
            <div class="flex">
                <div>
                    <h2>Telefone</h2>
                    <p>+55 11 2995 3412</p>
                    <h2>E-MAIL</h2>
                    <p>contato@vacuumcenter.com.br</p>
                    <h2>ENDEREÇO</h2>
                    <p>Av. Cel Sezefredo Fagundes, 6430</p>
                    <p>São Paulo - SP - Brasil - CEP: 02366-000</p>
                </div>
                <div>
                    <h2>Envie uma mensagem</h2>
                    <form @submit.prevent="submit">
                        <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
                            <input id="form-contact-name" class="form__input" v-model.trim="$v.name.$model"/>
                            <label for="form-contact-name" class="form__label" :class="{'up': $v.name.$model }">Nome</label>
                            <div class="error" v-if="!$v.name.required">Digite seu nome</div>
                            <div class="error" v-if="!$v.name.minLength">Seu nome deve conter pelo menos {{$v.name.$params.minLength.min}} caracteres.</div>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
                            <input id="form-contact-email" class="form__input" v-model.trim="$v.email.$model"/>
                            <label for="form-contact-email" class="form__label" :class="{'up': $v.email.$model }">E-mail</label>
                            <div class="error" v-if="!$v.email.required">Digite seu e-mail</div>
                            <div class="error" v-if="!$v.email.email">Digite seu e-mail corretamente</div>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.phone.$error }">
                            <input id="form-contact-phone" v-mask="['(##) ####-####', '(##) #####-####']" class="form__input" v-model.trim="$v.phone.$model"/>
                            <label for="form-contact-phone" class="form__label" :class="{'up': $v.phone.$model }">Telefone</label>
                            <div class="error" v-if="!$v.phone.required">Digite seu telefone</div>
                            <div class="error" v-if="!$v.phone.minLength">Digite seu telefone corretamente</div>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.company.$error }">
                            <input id="form-message-company" class="form__input" v-model.trim="$v.company.$model"/>
                            <label for="form-message-company" class="form__label" :class="{'up': $v.company.$model }">Empresa</label>
                            <div class="error" v-if="!$v.company.required">Digite o nome de sua empresa</div>
                            <div class="error" v-if="!$v.company.minLength">O nome de sua empresa deve conter pelo menos {{$v.company.$params.minLength.min}} caracteres.</div>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.document.$error }">
                            <input id="form-message-document" v-mask="'##.###.###/####-##'" class="form__input" v-model.trim="$v.document.$model"/>
                            <label for="form-message-document" class="form__label" :class="{'up': $v.document.$model }">CNPJ</label>
                            <div class="error" v-if="!$v.document.minLength">Digite o CNPJ corretamente</div>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.message.$error }">
                            <textarea id="form-contact-message" class="form__input" v-model.trim="$v.message.$model"></textarea>
                            <label for="form-contact-message" class="form__label" :class="{'up': $v.message.$model }">Mensagem</label>
                            <div class="error" v-if="!$v.message.required">Escreva sua mensagem</div>
                            <div class="error" v-if="!$v.message.minLength">Sua mensagem deve conter pelo menos {{$v.message.$params.minLength.min}} caracteres.</div>
                        </div>
                        <button class="button" type="button" @click="sendMessage()">Enviar mensagem</button>
                    </form>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import moment from 'moment'
export default {
    name: "Contact",
    components: {

    },
    data(){
        return {
            name: '',
            email: '',
            phone: '',
            company: '',
            message: '',
            document: '',
            loading: false,
            form: {
                name: '',
                email: '',
                phone: '',
                company: '',
                message: '',
                extra: {
                    createdAt: null,
                    status: 1,
                    type: 1
                },
                info: "",
                completeInfo: {}
            }
        }
    },
    validations: {
        name: {
            required,
            minLength: minLength(4)
        },
        phone: {
            required,
            minLength: minLength(14)
        },
        company: {
            required,
            minLength: minLength(4)
        },
        document: {
            minLength: minLength(17)
        },
        email: {
            required,
            email
        },
        message: {
            required,
            minLength: minLength(10)
        }
    },
    watch: {
        'document'(nV){
            if(nV.length == 18){
                const DOCUMENT = nV.replace(/\D/g, '');
                this.$http.get(`https://bluu.com.br/receita.php?cnpj=${DOCUMENT}`).then((response) => {
                    if(response.message && response.message == 'CNPJ inválido'){
                        this.form.info = 'CNPJ Inválido - ' + nV
                    }
                    else{
                        const res = response.data
                        this.form.completeInfo = res
                        let info = []
                        info.push('<h3>Dados capturados automaticamente</h3>');
                        info.push(`<p>CNPJ: <strong>${res.cnpj}</strong></p>`);
                        info.push(`<p>Capital social: <strong>${res.capital_social}</strong></p>`);
                        info.push(`<p>Nome: <strong>${res.nome}</strong></p>`);
                        info.push(`<p>Abertura: <strong>${res.abertura}</strong></p>`);
                        info.push(`<p>Porte: <strong>${res.porte}</strong></p>`);
                        info.push(`<p>Situação: <strong>${res.situacao}</strong></p>`);
                        if(res && res.hasOwnProperty('atividade_principal') && res.atividade_principal.length)
                        info.push(`<p>Atividade principal: <strong>${res.atividade_principal[0].text} (${res.atividade_principal[0].code})</strong></p>`);
                        info.push(`<p>Cidade/UF: <strong>${res.municipio}/${res.uf}</strong></p>`);
                        this.form.info = info.join('');
                    }
                })
            }
            else{
                this.form.info = 'CNPJ não foi preenchido.'
            }
        }
    },
    mounted(){
        // sgMail.setApiKey('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')

    },
    methods: {
        submit() {
            console.log('submit!')
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
            // do your submit logic here
            this.submitStatus = 'PENDING'
            setTimeout(() => {
              this.submitStatus = 'OK'
              this.sendMessage()
            }, 500)
            }
        },
        sendMessage(){
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
                this.loading = true

                
                this.form.name = this.name
                this.form.email = this.email
                this.form.company = this.company
                this.form.phone = this.phone
                this.form.message = this.message
                this.form.document = this.document
                


                this.form.extra.createdAt = moment().format('X') 
                this.form.extra.status = 0
                
                this.$db.collection('messages').add(this.form).then(() => {
                    this.$root.alerts.push({msg: 'Sua mensagem foi enviada com sucesso.', type: 'success'})
                }).catch((err) => {
                    this.$root.alerts.push({msg: 'Ocorreu um erro ao enviar sua mensagem.', type: 'error'})
                    console.error(err)
                    this.loading = false
                })
            }
        },
    }
}
</script>